import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './core/services/theme.service';
import { InfoModalComponent } from './features/page-components/info-modal/info-modal';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet,
    InfoModalComponent
  ],
})
export class AppComponent {
  /** Eagerly applies light-only theme on all routes (including login, signup). */
  private readonly _theme = inject(ThemeService);
}